import { $authHost } from '@/http/index'

export const checkAccessToken = async () => {
  const { data } = await $authHost.get(
    'users/profile?expand=roles,file,change_history,category,user_setting,avatar,organization_type,partner_type',
  )
  return data
}
